import { Component, OnDestroy, Input, TemplateRef, ContentChild } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';


@Component({
    selector: 'btn-cell-renderer',
    template: 
    // `
    //   <button (click)="btnClickedHandler($event)">Click me!</button>
    // `,
    `
		<em class="table_edit" *ngIf="enableEdit">
		<img [style]="boardPage? 'margin-right: 10px;cursor:pointer;' : 'margin-right:16px;cursor:pointer;'" 
		src="./assets/images/edit_blue.svg" 
		(click)="btnClickedHandler('edit')"> 
		</em>

		<em *ngIf="enableDelete">
		<img style="cursor:pointer;" class="table_delete" src="./assets/images/delete_red.svg" 
		(click)="btnClickedHandler('delete')">
		</em>`,
    standalone: false
})
export class BtnCellRenderer implements ICellRendererAngularComp, OnDestroy {



	refresh(params: ICellRendererParams): boolean {
		throw new Error(`Error while refreshing renderer component. INFO-${params}`);
	}

	private params: any;
	pageName;
	enableEdit: boolean = true;
	enableDelete: boolean = true;

	agInit(params: any): void {
		this.params = params;
		this.pageName = this.params.colDef.field;

		//tier
		if (this.params.colDef.field == "tier_editdelete") {  // NOSONAR

			if (this.params.data.SHOW_EDIT == '0') {  // NOSONAR
				this.enableEdit = false;
			}
			else if (this.params.data.SHOW_EDIT == '1') {  // NOSONAR
				this.enableEdit = true;
			}

			if (this.params.data.SHOW_DELETE == '0') {  // NOSONAR
				this.enableDelete = false;
			}
			else if (this.params.data.SHOW_DELETE == '1') {  // NOSONAR
				this.enableDelete = true;
			}

		}

		//shuttle
		if (this.params.colDef.field == "shuttle_editdelete") {  // NOSONAR

			if (this.params.data.SHOW_EDIT == '0') {  // NOSONAR
				this.enableEdit = false;
			}
			else if (this.params.data.SHOW_EDIT == '1') {  // NOSONAR
				this.enableEdit = true;
			}

			if (this.params.data.SHOW_DELETE == '0') {  // NOSONAR
				this.enableDelete = false;
			}
			else if (this.params.data.SHOW_DELETE == '1') {  // NOSONAR
				this.enableDelete = true;
			}

		}
	}

	btnClickedHandler(action) {

	

		//tiersetup
		if (action == 'delete') { // NOSONAR
			this.params.context.componentParent.deleteTemplateRow(this.params.data, this.pageName);
		}

		else if (action == 'edit') {  // NOSONAR
			this.params.context.componentParent.editTemplateRow(this.params.data, this.pageName);
		}
	}

	ngOnDestroy() {
console.info()


	}
}
